import { render, staticRenderFns } from "./addclaimb.vue?vue&type=template&id=4688d8d0&scoped=true&"
import script from "./addclaimb.vue?vue&type=script&lang=js&"
export * from "./addclaimb.vue?vue&type=script&lang=js&"
import style0 from "./addclaimb.vue?vue&type=style&index=0&id=4688d8d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4688d8d0",
  null
  
)

export default component.exports